import { render } from "./fileuploadfield.vue?vue&type=template&id=2b846901&scoped=true"
import script from "./fileuploadfield.vue?vue&type=script&lang=js"
export * from "./fileuploadfield.vue?vue&type=script&lang=js"

import "./fileuploadfield.vue?vue&type=style&index=0&id=2b846901&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b846901"]])

export default __exports__